import { Tag } from "@chakra-ui/react";
import type { LandlordProperties } from "modules/landlord-portal/models/overview";
import { PropertyTenancyStatus } from "types/property";
import { titleCase } from "utils/string";

type StatusCellProps = {
  row: LandlordProperties;
};
export function StatusCell({ row }: StatusCellProps) {
  return (
    <Tag
      colorScheme={
        row.status.id === PropertyTenancyStatus.Active ? "green" : "gray"
      }
      fontSize={"sm"}
      fontWeight={600}
    >
      {titleCase(row.status.label)}
    </Tag>
  );
}
